module.exports = __webpack_public_path__ + "img/trueMoney.7f8d975.png";